import React, { useState, useMemo } from 'react'
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from 'axios';
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmDemoPayment, SubscribeUser } from "../redux/actions/UserAction";
import { GetAvalableHost, getRandomTeacherForDemo, CreateSession, getAvailableSlot } from "../redux/actions/SessionAction";
import { availableDate, TimeValidator, getAvailableTeacherSate, localToutcTimeConverter, slotFormatAMPM, overlapUTCtimeConverter, formatTimeslot } from "../helpers/TimeDate";
import { CreateZoomMeeting } from "../redux/actions/ZoomMeeting";
import SubscriptionMessageModal from './MessageModal/SubscriptionMessageModal';
import Select from 'react-select'
import countryList from 'react-select-country-list'
import { useSnackbar } from "react-simple-snackbar";
import { getDevice } from "../helpers/PageHelper";



// const PUBLIC_KEY = "pk_live_51JRvxGSHt1oj0yR6CrQYjDVzwcZDbbPMqWyYj25yIYnz0Wvl962vIR9br6bOyL2MxxNSxBlSUPiutl3De5fpa0dw00NXfoOK0c";

//Test Key
const PUBLIC_KEY = "pk_test_51IyY2lSBYt2d7PwlSIZWkt45uMmmAoYCHRIf8pnEMxqHpLe2hp98rXlCY0oZ0vHCvqu24bRk0KvMDDf8M734TUrT00t69Bopd2"

const stripeTestPromise = loadStripe(PUBLIC_KEY);


export const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const [subscribeLoder, setSubscribeLoder] = useState(false);
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [country, setCountry] = useState("IN");
  const [state, setState] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const [value, setValue] = useState({ value: 'IN', label: 'India' })
  const options = useMemo(() => countryList().getData(), [])
  const history = useHistory();
  const isTrialClass = JSON.parse(localStorage.getItem("DEMO_SESSION"));
  const user = JSON.parse(localStorage.getItem("DEMOUSER"));
   const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
   const token = JSON.parse(localStorage.getItem("TOKEN"))
   if (token) {
     axios.defaults.headers.common["x-access-token"] = token;
     axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
     axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
   }
  const changeHandler = value => {
    setValue(value)
    setCountry(value.value)
  }



  console.log(props.data)
  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubscribeLoder(true)
    //DEMO PAYMENT IN IF BLOCK
    if (props.data.demoData) {
      setSubscribeLoder(true)
      console.log("DEMO PROPS", props.data.demoData)
      console.log(city)
      props.data.demoData.address.city = city;
      props.data.demoData.address.country = country;
      props.data.demoData.address.line1 = address;
      props.data.demoData.address.postal_code = postal;
      props.data.demoData.address.state = state;

      const data = props.data.demoData;
      console.log(data)

      //api call
      axios.post(`${process.env.REACT_APP_BASE_URL}/api/stripe/create-checkout-session-sdk`, data)
        .then(async function (response) {
          console.log(response)
          setSubscribeLoder(true)
          const paymentResult = await stripe.confirmCardPayment(response.data.paymentIntent, {
            payment_method: {
              card: elements.getElement(CardElement)
            },
          });
          console.log(paymentResult)
          if (!paymentResult.error) {
            console.log("Stripe 23 | token generated!", paymentResult);
            try {
              console.log("try block");
              if (paymentResult) {
                setSubscribeLoder(true)
                // console.log("Payment handler on success block")
                // setPaymentLoader(true)
          
                //confirm demo payment API call
                var demopayedData = {
                  transactionId: response.data.orderId,
                  learnerId: user._id
                }
                var demoPayed = (res) => {
                  // setDemoLoder(false);
                  console.log("demo payed success");
                  console.log(res);
                  localStorage.setItem("DEMO_SESSION", true);
                  // setPaymentSuccess(true)
          
                  // if (isAddPage === true || isAddPage === "true") {
                  //   localStorage.removeItem("ADD_PAGE")
                  //   ReactPixel.track("Start trial", { "Adult website": true });
                  //   localStorage.setItem("ADD_PAGE_USER", true);
                  // }
                }
                var demoFailed = (errmsg) => {
                  // setDemoLoder(false);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: errmsg,
                  });
                }
                dispatch(ConfirmDemoPayment(demopayedData, demoPayed, demoFailed,token))
          
          
                //Get Random Teacher API call
                const getRandomTeacherSuccess = (res) => {
                  // setPaymentLoader(false)
                  console.log("get available random teacher successfully called")
                  // setTeacherData(res.teacher);
                  const teacherData = res.teacher;
                  const blockHostSuccess = (res, res2) => {
                    // setPaymentLoader(true)
                    console.log("blockhost on success block");
                    const hostData = res;
                    const hostId = res2;
          
                    //create meeting
                    // get available host & call createMeeting
          
          
                    const maindata = {
                      userId: hostData, //hostdata is email from block host api call
                      data: {
                        topic: "Clapingo Demo Session",
                        type: 2,
                        start_time: props.data.selectedTime.startTime,
                        duration: 15,
                        schedule_for: hostData,
                        timezone: "UTC",
                        password: "clapingo",
                        agenda: "Learn English",
                        settings: {
                          host_video: true,
                          participant_video: true,
                          cn_meeting: false,
                          in_meeting: true,
                          join_before_host: true,
                          mute_upon_entry: true,
                          watermark: false,
                          use_pmi: false,
                          approval_type: 2,
                          auto_recording: "cloud",
                          registrants_email_notification: true,
                        },
                      },
                    };
          
                    const onSuccess = (data) => {
                      // setPaymentLoader(true)
                      console.log("create zoom meeting onsuccess called")
                      if (teacherData) {
                        if (data) {
                          var meetingndata = {
                            meetingNo: String(data.id),
                            learner: props.data.demoData.notes.learnerID, //learnerid from props
                            teacher_: teacherData.teacher, //teacherid
                            startTime: props.data.selectedTime.startTime,
                            endTime: props.data.selectedTime.endTime,
                            sessionDate: getAvailableTeacherSate(props.data.selectedDate?.toUTCString()),
                            meetingPassword: data.password,
                            startMeetingUrl: data.start_url,
                            joinMeetingUrl: data.join_url,
                            host: data.host_email,
                            isAdmin: false,
                            isWebsite: true,
                            blockHostId: hostId,//blockhost api call id
                            timezone: time_zone.timezone,
                            isTimeUtc: true,
                            source:getDevice()
                          };
          
                          meetingndata["type"] = "Demo";
                          meetingndata["sessionDuration"] = "15min";
          
          
                          const onSuccess = () => {
                            // setPaymentLoader(false)
                            console.log("create clapingo meeting onsuccess called");
                            setSubscribeLoder(false);
          
                            if (
                              (user.isTrialBooked === false &&
                                user.isDemoPayed === true) ||
                              isTrialClass
                            ) {
                              localStorage.setItem("DEMO_BOOKED", JSON.stringify(true));
                              localStorage.setItem("DEMO_TIME", JSON.stringify(props.data.selectedTime));
                              // localStorage.setItem("DEMO_DATE", JSON.stringify(selectedDate));
                              localStorage.setItem("DEMO_DATE", JSON.stringify(getAvailableTeacherSate(props.data.selectedDate)));
                              localStorage.removeItem("DEMO_SESSION");
                              setSubscribeLoder(false);
                              history.replace({ pathname: 'success' });
                              Swal.fire("Demo Booked Successfully!", "", "success");
                              // window.location.reload();
                            } else {
                              Swal.fire("Session Booked Successfully!", "", "success");
                              localStorage.setItem("DEMO_TIME", JSON.stringify(props.data.selectedTime));
                              // localStorage.setItem("DEMO_DATE", JSON.stringify(selectedDate));
                              localStorage.setItem("DEMO_DATE", JSON.stringify(getAvailableTeacherSate(props.data.selectedDate)));
                              history.replace({ pathname: 'success' });
                              // window.location.reload();
                            }
                          };
                          const onError = (err) => {
                            openSnackbar("create meeting error")
                            console.log(err)
                            setSubscribeLoder(false);
                            Swal.fire({
                              icon: "error",
                              title: "Oops...",
                              text: err,
                            });
                          };
                          dispatch(CreateSession(meetingndata, onSuccess, onError, token));
                        } else {
                          setSubscribeLoder(false);
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Unable to book meeting due to some technical reason please try again later",
                          });
                        }
                      }
                      else {
                        setSubscribeLoder(false);
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Teacher data not available",
                        });
                      }
                    };
                    const onError = () => {
                      setSubscribeLoder(false);
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Oops something went wrong !!",
                      });
                    };
                    dispatch(CreateZoomMeeting(maindata, onSuccess, onError));
                  }
                  const blockHostError = (res) => {
                    setSubscribeLoder(false)
                    console.log("blockhost error block")
                    openSnackbar("blockhost error")
                    console.log(res)
                  }
                  dispatch(
                    GetAvalableHost(
                      {
                        startTime: props.data.selectedTime.startTime,
                        endTime: props.data.selectedTime.endTime,
                        sessionDate: getAvailableTeacherSate(props.data.selectedDate),
                        isTimeUtc: true,
                      },
          
                      blockHostSuccess,
                      blockHostError,
                      token
                    )
                  );
                }
                const getRandomTeacherError = (res) => {
                  setSubscribeLoder(false)
                  console.log("get available teacher error block");
                  openSnackbar("Book teacher error/Teacher not available at that time")
                  console.log(res)
                }
          
                dispatch(
                  getRandomTeacherForDemo(
                    {
                      // sessionTime: TimeValidator(localToutcTimeConverter(selectedTime.start)),    
                      sessionTime: props.data.selectedTime.startTime,
                      sessionEndTime: props.data.selectedTime.endTime,
                      sessionDate: getAvailableTeacherSate(props.data.selectedDate),
          
                    },
                    getRandomTeacherSuccess,
                    getRandomTeacherError,
                    token
                  )
                );
          


              }

            } catch (error) {
              setSubscribeLoder(false)
              console.log("Error", error)
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: paymentResult.error.code,
              });
            }
          } else {
            setSubscribeLoder(false)
            console.log(paymentResult)
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: paymentResult.error.message,
            });
          }
        })
        .catch(error => {
          console.log('ERROR', error.response)
          
        })
      
      
    }
    //SUBSCRIPTION PAYMENT IN ELSE BLOCK
    else {
      //modifying object with address
      props.data.data.address.city = city;
      props.data.data.address.country = country;
      props.data.data.address.line1 = address;
      props.data.data.address.postal_code = postal;
      props.data.data.address.state = state;

      const data = props.data.data;
      console.log(data)
      //api call
      axios.post(`${process.env.REACT_APP_BASE_URL}/api/stripe/create-checkout-session-sdk`, data)
        .then(async function (response) {
          console.log(response)
          setSubscribeLoder(true)
          const paymentResult = await stripe.confirmCardPayment(response.data.paymentIntent, {
            payment_method: {
              card: elements.getElement(CardElement)
            },
          });
          console.log(paymentResult)
          if (!paymentResult.error) {
            console.log("Stripe 23 | token generated!", paymentResult);
            try {
              console.log("try block");
              if (paymentResult) {
                setSubscribeLoder(true)
                var data = {
                  learnerId: props.data.data.notes.learnerID,
                  planId: props.data.data.notes.planId,
                  month: props.data.data.notes.month,

                  zone1: props.data.data.notes.zone1,
                  zone2: props.data.data.notes.zone2,

                  paymentDetails: props.data.data.notes.subscriptionName + "(from web)",
                  order_id: response.data.orderId,
                  currency: props.data.data.currency,
                  subscriptionName: props.data.data.notes.subscriptionName,
                  transactionId: response.data.orderId,
                  amount: props.data.data.amount,
                  source: props.data.data.source,
                };

                if (props.data.data.notes.influencer) {
                  data["influencer"] = props.data.data.notes.influencer;
                  data["amountWithoutGST"] = Math.round(props.data.data.amount - props.data.data.amount * 0.18);
                }
                if (props.data.data.notes.isWallet) {
                  data["isWallet"] = props.data.data.notes.isWallet;
                  data["walletAmount"] = props.data.data.notes.walletAmount;
                }

                console.log("DATA", data)

                const subscriptionSuccess = (res) => {
                  localStorage.setItem("SUBSCRIBED", JSON.stringify(true));
                  // handleShow();
                  console.log("subscription success")
                  console.log(res)
                  setSubscribeLoder(false);
                  setShow(true);
                };

                const subscriptionFailed = (errmsg) => {
                  setSubscribeLoder(false);
                  console.log("subscription failed")
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: errmsg,
                  });
                };
                console.log(data);
                dispatch(SubscribeUser(data, subscriptionSuccess, subscriptionFailed));


              }

            } catch (error) {
              setSubscribeLoder(false)
              console.log("Error", error)
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: paymentResult.error.message,
              });
            }
          } else {
            setSubscribeLoder(false)
            console.log(paymentResult.error.code)
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: paymentResult.error.message,
            });
          }
        });
      // const { error, paymentMethod } = await stripe.createPaymentMethod({
      //   type: "card",
      //   card: elements.getElement(CardElement)
      // })
      // console.log(checkoutData)

      // const result = await stripe.confirmPayment({
      //   //`Elements` instance that was used to create the Payment Element
      //   elements,
      //   confirmParams: {
      //     return_url: "https://my-site.com/order/123/complete",
      //   },
      // });

    }
  }

  return (

    <form onSubmit={handleSubmit} style={{ maxWidth: "100%" }} className='mx-auto'>
      <SubscriptionMessageModal show={show} handleClose={handleClose} />
      <div className='mb-2 stripe-input'>
        <div>

          <input
            id="address"
            type="text"
            className="form-control RegInput2 "
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
          />
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>

            <input
              id="city"
              type="text"
              className="form-control RegInput2 "
              placeholder="city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              required
            />
          </div>

          <div className='col-md-6'>
            <input
              id="address"
              type="text"
              className="form-control RegInput2 "
              placeholder="Postal Code"
              value={postal}
              onChange={(e) => setPostal(e.target.value)}
              required
            />
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col-md-6'>
            <input

              id="address"
              type="text"
              className="form-control RegInput2 "
              placeholder="State"
              value={state}
              onChange={(e) => setState(e.target.value)}
              required
            />
          </div>
          <div className='col-md-6 '>
            <Select options={options} value={value} onChange={changeHandler} />
          </div>
        </div>

      </div>
      <CardElement
        className="stripe-card"
        options={{
          hidePostalCode: true,
          style: {
            base: {
              color: '#3b3d42',
              fontSize: '17px',
              fontFamily: '"Open Sans", sans-serif',
              fontSmoothing: 'antialiased',
              '::placeholder': {
                color: '#3b3d42',
              },
            },
            invalid: {
              color: '#e5424d',
              ':focus': {
                color: '#e5424d',
              },
            },
          },
        }}
      />
      <button className="payment_btn mx-auto mt-4">{subscribeLoder
        ? "Processing..."
        : "Make Payment"}</button>
    </form>
  );
};


const StripePaymentHandler = (props) => {
  return (
    <Elements stripe={stripeTestPromise}>
      <CheckoutForm data={props} />
    </Elements>
  );
};



export default StripePaymentHandler